import React, { useContext } from 'react'

import { ButtonV2, Text } from '@vividseats/vivid-ui-kit'

import DateFilterWrapper from '@/components/shared/filters/date-filter-wrapper'
import FilterButton from '@/components/shared/filters/filter-button'
import { CATEGORY_OPTIONS } from '@/components/shared/filters/multi-filter/production-type-filter/constants'
import { CATEGORY_IDS } from '@/constants'
import ProductionListContext from '@/context/productions-list'
import ProductionTotalsContext from '@/context/productions-total/context'
import type { FilterOption } from '@/types/app-types'

import styles from './styles.module.scss'

const VenueFilterBar = () => {
    const {
        selectors: {
            params: { categoryId, subCategoryId, endDate, startDate },
        },
        dispatch: { onFilterChangeAction },
    } = useContext(ProductionListContext)

    const {
        state: { data },
    } = useContext(ProductionTotalsContext)
    const totalProductions = data?.totalProductions ?? 0
    const categoryTotals = data?.categoryTotals ?? {}

    const oneOrLessProduction = totalProductions <= 1
    // for context: categoryTotals has the categoryId as a key, count as value
    const allEventsSameCategory = Object.keys(categoryTotals).length === 1

    const shouldHideAllChips = allEventsSameCategory || oneOrLessProduction

    // more param checking may need to be added here as we expand the filtering capabilities
    // if all of these are undefined, we do not have filters applied
    const isShowingResetButton = [categoryId, subCategoryId, endDate, startDate].some((filter) => filter !== undefined)

    const handleChange = ({ value: categoryId }: FilterOption<CATEGORY_IDS | undefined>) => {
        onFilterChangeAction({ categoryId })
    }

    const handleReset = () => {
        // Same as an above comment, if we add more params, they will have to be reest manually in here
        onFilterChangeAction({
            startDate: undefined,
            endDate: undefined,
            categoryId: undefined,
            subCategoryId: undefined,
        })
    }

    return (
        <div className={styles.outerContainer}>
            <div className={styles.container}>
                <div className={styles.mobileSpacer}></div>
                <div className={styles.buttons}>
                    {/* TODO: design-debt: Chip */}
                    <DateFilterWrapper customLabel="Any Date" />
                    {!shouldHideAllChips &&
                        CATEGORY_OPTIONS.map((option) => {
                            // All types is an option with no value that we don't want to show
                            if (!option || !option.value) {
                                return null
                            }

                            const shouldHideChip = !categoryTotals[option.value]
                            if (shouldHideChip) {
                                return null
                            }

                            const selected = categoryId === option.value
                            const onClick = () => {
                                handleChange(selected ? { label: 'All Types' } : option)
                            }
                            // BWCT-375: The requirements want us to change this for just the chip, not everywhere in the code
                            const label = option.label === 'Theater' ? 'Theater & Comedy' : option.label
                            return (
                                // TODO: design-debt: Chip
                                <FilterButton
                                    key={option.value}
                                    active={selected}
                                    onClick={onClick}
                                    dataTestId={`filter-button-category-${option.value}`}
                                >
                                    {label}
                                </FilterButton>
                            )
                        })}
                    {isShowingResetButton && (
                        <ButtonV2
                            importance="text"
                            noFill
                            size="small"
                            data-testid="filter-reset-button"
                            onClick={handleReset}
                        >
                            <Text altFont size="md" weight="semi-bold">
                                Reset
                            </Text>
                        </ButtonV2>
                    )}
                </div>
                <div className={styles.mobileSpacer}></div>
            </div>
        </div>
    )
}

export default VenueFilterBar
